import React, { MutableRefObject, ReactNode, useEffect, useRef, useState } from 'react';
import { useCampaignLinks } from './hooks/useCampaignLinks'
import { useTranslation } from 'react-i18next';
const CampaignLinks = () => {
  const [ showAdditionalItems, setShowAdditionalItems ] = useState(false);
  const { links, getCampaignLinks } = useCampaignLinks();
  const initialShowedAmount = 7;

  useEffect(() => {
    getCampaignLinks();
  }, [])

  return (
    <>
      <ul className="links-list">
        {links && links.slice(0, initialShowedAmount).map((link, index) => (
          <Link key={index} url={link.href} text={link.text} />
        ))}

        {links && links.length > initialShowedAmount && (
          <>
            <div
              className={`additional-list-items ${showAdditionalItems ? 'show' : ''}`}
              aria-expanded={showAdditionalItems ? 'true' : 'false'}
            >
              {links.slice(initialShowedAmount).map((link, index) => (
                <Link key={index} url={link.href} text={link.text} />
              ))}
            </div>
            <MoreButton isActive={showAdditionalItems} onClick={() => setShowAdditionalItems(!showAdditionalItems)} />
          </>
        )}
      </ul>
    </>
  )
}

const Link = ({url, text} : {url: string, text: string}) => {
  const linkRef = useRef<null | HTMLLIElement>(null)
  const observerRef = useRef<IntersectionObserver | null>(null);

  const addInitialClass = (element: HTMLLIElement | null) => {
    if (!element) return;
    element.classList.add('transition');
  }

  const observe = (element: HTMLLIElement | null) => {
    if (!element) return;

    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
            unobserve((entry.target as HTMLLIElement));
          }/* else {
            entry.target.classList.remove("visible");
          }*/
        });
      },
      { threshold: 0.5 }
    );

    observerRef.current.observe(element);
  }

  const unobserve = (element: HTMLLIElement | null) => {
    if (!element || !observerRef.current) return;
    observerRef.current.unobserve(element);
  }

  useEffect(() => {
    const el = linkRef.current;
    addInitialClass(el);
    observe(el);
    return () => unobserve(el);
  }, [])

  return (
    <li className="links-list-item" ref={linkRef}>
      <a href={url}>{text}</a>
    </li>
  )
}

const MoreButton = ({ isActive, onClick } : { isActive: boolean, onClick: () => void }) => {
  const { t } = useTranslation();
  return (
    <button
      className="more-button"
      onClick={onClick}
      aria-expanded={isActive ? 'true' : 'false'}
      title={isActive ? 'Hide items' : 'Show all items'}
    >
      {!isActive ? `+${t('common.more')}` : `-${t('common.less')}`}
    </button>
  )
}

export default CampaignLinks;